// Third-party
import React from 'react';
import { Link } from 'react-router-dom';
import { withFormik, FormikProps, Form } from 'formik';
import * as Yup from 'yup';

// Components
import { Button } from '@capintel/component-lib/button';
import { FormInput } from '../../components/forms';

// Utils
import { formatMessage } from '../../../utils/i18n';
import { FormattedMessageV2 } from '@/views/components/i18n';

type FormProps = {
  email: string;
  password: string;
};

type ParentProps = {
  signingIn: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  onSubmit: (email: string, password: string) => Promise<void>;
};

type Props = ParentProps & FormikProps<FormProps>;

const canSubmit = (props: Props) => {
  const { values, initialValues, isSubmitting, errors } = props;

  const hasErrors = Object.keys(errors).length > 0;
  const isDirty = values !== initialValues;

  return !hasErrors && isDirty && !isSubmitting;
};

const Login = (props: Props) => (
  <>
    <FormattedMessageV2 className="form-title" toLocalize="Auth.Login.SignInTitle" />

    <Form>
      <FormInput name="email" label={formatMessage('Auth.Email')} placeholder="james@mail.com" />

      <FormInput name="password" type="password" label={formatMessage('Auth.Password')} />

      <Link to="forgot-password" tabIndex={-1} className="link">
        {formatMessage('Auth.ForgotPassword.Link')}
      </Link>

      <div className="submit-container">
        <Button variant="primary" data-testid="signin-button" type="submit" loading={props.signingIn} disabled={!canSubmit(props)}>
          {formatMessage(props.signingIn ? 'Auth.LogingIn' : 'Auth.LogIn')}
        </Button>

        <Link to="sso" className="link">
          {formatMessage('Auth.Login.SSOLink')}
        </Link>
      </div>
    </Form>
  </>
);

const LoginSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
});

const formikWrapper = withFormik<Props, FormProps>({
  validationSchema: LoginSchema,
  mapPropsToValues: () => ({ email: '', password: '' }),
  handleSubmit: ({ email, password }, { props, setSubmitting }) => {
    props.onSubmit(email, password).finally(() => {
      setSubmitting(false);
    });
  },
});

export default formikWrapper(Login) as any;
